import * as React from 'react';

import { useQuery } from '@tanstack/react-query';

import { useApi } from './useApi';
import {
  createBatchPermissionsQueryOptions,
  type PermissionScope,
} from './usePermission';

import type { AllPermissionKeys } from '~/modules/settings/_generated/permissions';

export function usePermissions(
  actions: AllPermissionKeys[],
  scope?: PermissionScope,
): {
  permissions: Map<string, boolean>;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
} {
  const { client } = useApi();

  const { data, isLoading, isError, error } = useQuery(
    createBatchPermissionsQueryOptions(client, actions, scope),
  );

  const permissions = React.useMemo(
    () => data ?? new Map<string, boolean>(),
    [data],
  );

  return {
    permissions,
    isLoading,
    isError,
    error,
  };
}
